/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum DateFormatPreference {
  AUTO="AUTO",
DDMMYYYY="DDMMYYYY",
MMDDYYYY="MMDDYYYY",
YYYYMMDD="YYYYMMDD"
}

/**
* DateFormatPreference
*/
export const DateFormatPreferenceEnumType = types.enumeration("DateFormatPreference", [
        "AUTO",
  "DDMMYYYY",
  "MMDDYYYY",
  "YYYYMMDD",
      ])
